import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import CatalogPage        from './catalog'
import ManageMyRlinkPage  from './manage-my-rlink'
import ProductDetailsPage from './product-details'

import component from './vehicle.component'

let module = angular.module('vehicle', [
  uiRouter,
  CatalogPage,
  ManageMyRlinkPage,
  ProductDetailsPage
])

.config(($stateProvider) => {
  'ngInject'

  $stateProvider
    .state('vehicle', {
      url: '/vehicle/:vin?token',
      component: 'vehicle',
      authenticate: true,
      params: {
        sync: true
      },
      redirectTo: (trans) => {
        const svc = trans.injector().get('VehicleService')
        const vin = trans.params().vin
        const sync = trans.params().sync
        const $rootScope = trans.injector().get('$rootScope')
        $rootScope.$broadcast('globalSpinner:on')
        if (sync) {
          console.debug('Sync todo')
          return svc.synchronizeVehicleInfoAndRights(vin)
          .then(() => {
            console.log('Info and rights synchronized', vin)
          })
          .catch(() => {
            console.error('Info and rights not synchronized', vin)
          })
          .finally(() => {
            return svc.setCurrentSelectedVehicle(vin, false)
          })
          .then(() => {
            console.log('Goto vehicle page', vin)
            $rootScope.$broadcast('globalSpinner:off')
            return Promise.resolve('vehicle.catalog')
          })
          .catch((err) => {
            console.error('Unable to switch vehicle', err)
            $rootScope.$broadcast('globalSpinner:off')
            return Promise.resolve('home')
          })
        } else {
          console.debug('Sync not needed')
          return svc.setCurrentSelectedVehicle(vin, false)
          .then(() => {
            console.log('Goto vehicle page', vin)
            $rootScope.$broadcast('globalSpinner:off')
            return Promise.resolve('vehicle.catalog')
          })
          .catch((err) => {
            console.error('Unable to switch vehicle', err)
            $rootScope.$broadcast('globalSpinner:off')
            return Promise.resolve('home')
          })
        }
      }
    })
})

.component('vehicle', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/index.js